




























import * as _ from 'lodash';
import {Vue, Component, Prop} from 'vue-property-decorator';
import {Route} from 'vue-router';
import {Getter, namespace} from 'vuex-class';
import {ProjectMetadata, ProjectsMetadata} from '../../metadata/projects-metadata.d';
import featuredImages from './static';
import documentations from './documentations';
import mainToolbar from '../toolbar/toolbar.vue';
import {markdownWriter} from '../../services';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate',
]);

const MainGetter = namespace('main', Getter);

@Component({
  components: {
    mainToolbar,
  },
})
export default class ProjectDocumentations extends Vue {
  @MainGetter('availableProjects') private availableProjects: ProjectsMetadata;

  private projectId: string = '';
  private project: ProjectMetadata | null = null;

  private beforeRouteEnter(to: Route, from: Route, next: (cb: any) => void) {
    next((vm: ProjectDocumentations) => {
      vm.updateProjectMetadata();
    });
  }

  private beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    this.updateProjectMetadata(to.params.id);
    next();
  }

  private updateProjectMetadata(id?: string) {
    this.projectId = id || this.$router.currentRoute.params.id;
    this.project = _.find(this.availableProjects, ['id', this.projectId]) as ProjectMetadata;
  }

  private get featureImage() {
    return featuredImages[this.projectId];
  }

  private get compiledMarkdown(): string {
    return markdownWriter.render(documentations[this.projectId]);
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/project-documentations/project-documentations.vue